import axios from 'axios';
import type { ContractType } from '../types';

const API_URL = '';

export async function getContractTypes() {
  const res = await axios.get<ContractType[]>(`${API_URL}/api/contract-types`);
  return res.data;
}
